import { Toaster } from 'sonner';
import { useTheme } from '@/lib/theme';

/** Toasts aux couleurs du thème affiché (sonner ne lit pas la classe `dark`) */
export function ThemedToaster() {
  const { dark } = useTheme();

  return <Toaster richColors position="top-right" theme={dark ? 'dark' : 'light'} />;
}
